import createClient from "openapi-fetch";

import { getConfig } from "../config";
import type { paths } from "./schema";

// The clinic is identified by the `subdomain` the SPA sends in the
// `/auth/login` body (BE-1783) — derived from window.location in deployed envs,
// or a dev-only input field on localhost; the backend uses the request Host
// only as a fallback. So this base URL is just the configured backend host;
// login does not depend on per-clinic host routing.
const baseUrl = getConfig().apiUrl;

export const apiClient = createClient<paths>({ baseUrl });
